// extracted by mini-css-extract-plugin
export var logoWrapper = "hD_BY";